import { Spin } from "antd";
export const CascadeLoading = () => {
    return (
        <>
            <div className={"flex flex-col gap-2 items-center justify-center"}>
                <Spin />
            </div>
        </>
    );
};
